import { Routes } from '@datadog/browser-rum-react/react-router-v6';
import { Route, Navigate } from 'react-router-dom';

import Chronos from './Chronos';
import Settings from './Settings';
import Liability from './static-pages/liability';
import Privacy from './static-pages/privacy';
import { ReleaseNotes } from './static-pages/ReleaseNotes';
import { V2Announcement } from './static-pages/V2Announcement';
import { redirectToNewFrontend } from '@/utils/redirectToNewFrontend';

const Screens = () => {
  // uncomment this line to enable redirecting for CC
  redirectToNewFrontend();

  return (
    <Routes>
      <Route path="liability" element={<Liability />} />
      <Route path="privacy" element={<Privacy />} />
      <Route path="release-notes" element={<ReleaseNotes />} />
      <Route path="settings" element={<Settings />} />
      <Route path="chronos/*" element={<Chronos />} />
      <Route path="announcement" element={<V2Announcement />} />
      <Route path="*" element={<Navigate to="/app/chronos" />} />
    </Routes>
  );
};

export default Screens;
